module.exports = __webpack_public_path__ + "img/qrcode.ff4d2c28.jpg";